module.exports = __webpack_public_path__ + "img/icon_ticket.e71631e3.svg";